export const USER_ROLE_USER = 'user'
export const USER_ROLE_ADMIN = 'admin'
export const USER_ROLE_SUPER_ADMIN = 'super-admin'

export type UserRole =
  | typeof USER_ROLE_USER
  | typeof USER_ROLE_ADMIN
  | typeof USER_ROLE_SUPER_ADMIN

export function normalizeUserRole(raw: unknown): UserRole | undefined {
  const value = String(raw || '')
    .trim()
    .toLowerCase()

  if (!value) return undefined
  if (value === USER_ROLE_ADMIN) return USER_ROLE_ADMIN
  if (
    value === USER_ROLE_SUPER_ADMIN ||
    value === 'super_admin' ||
    value === 'superadmin'
  ) {
    return USER_ROLE_SUPER_ADMIN
  }
  if (value === USER_ROLE_USER) return USER_ROLE_USER

  return undefined
}

export function isAdminUserRole(raw: unknown) {
  const role = normalizeUserRole(raw)
  return role === USER_ROLE_ADMIN || role === USER_ROLE_SUPER_ADMIN
}
